import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/contexts/LanguageContext";
import { Mail } from "lucide-react";

const L = {
  it: {
    tag: "Scopri quanto vale davvero il tuo usato e vendilo al prezzo giusto, con l'aiuto dell'intelligenza artificiale.",
    product: "Prodotto",
    valuate: "Valuta un oggetto",
    guide: "Guide",
    history: "La mia cronologia",
    legal: "Legale",
    privacy: "Privacy & Cookie",
    terms: "Termini di Servizio",
    contact: "Contatti",
    rights: "Tutti i diritti riservati.",
  },
  en: {
    tag: "Discover what your used items are really worth and sell them at the right price, with the help of AI.",
    product: "Product",
    valuate: "Value an item",
    guide: "Guides",
    history: "My history",
    legal: "Legal",
    privacy: "Privacy & Cookie",
    terms: "Terms of Service",
    contact: "Contact",
    rights: "All rights reserved.",
  },
};

export const Footer = () => {
  const { lang } = useLang();
  const t = L[lang] || L.it;

  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-white border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Link to="/" className="inline-flex items-center gap-2">
            <span className="font-display font-black text-2xl tracking-tight">ReValue</span>
            <span className="font-mono text-[10px] tracking-widest text-[#FFCC00] uppercase">/ Resale Value Engine</span>
          </Link>
          <p className="mt-4 text-sm text-[#A0A0A0] leading-relaxed max-w-sm">{t.tag}</p>
          <a href="mailto:info@re-value.net" data-testid="footer-email" className="inline-flex items-center gap-2 mt-5 font-mono text-sm font-bold text-white hover:text-[#FFCC00] transition-colors">
            <Mail size={15} /> info@re-value.net
          </a>
        </div>

        <div className="md:col-span-3 md:col-start-8">
          <div className="overline text-[#737373]">{t.product}</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/valutazione" className="text-[#D4D4D4] hover:text-white transition-colors">{t.valuate}</Link></li>
            <li><Link to="/guide" data-testid="footer-guide" className="text-[#D4D4D4] hover:text-white transition-colors">{t.guide}</Link></li>
            <li><Link to="/cronologia" className="text-[#D4D4D4] hover:text-white transition-colors">{t.history}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="overline text-[#737373]">{t.legal}</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/privacy" data-testid="footer-privacy" className="text-[#D4D4D4] hover:text-white transition-colors">{t.privacy}</Link></li>
            <li><Link to="/termini" data-testid="footer-terms" className="text-[#D4D4D4] hover:text-white transition-colors">{t.terms}</Link></li>
            <li><Link to="/contatti" data-testid="footer-contact" className="text-[#D4D4D4] hover:text-white transition-colors">{t.contact}</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 py-6">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-wrap items-center justify-between gap-2 text-xs font-mono text-[#737373]">
          <span>© 2026 ReValue. {t.rights}</span>
          <span>v 1.0.0</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
